import fire from "../../../assets/images/icons/fire.png";
import feature1Bg from "../../../assets/images/feature_1.png";

export interface KeyFeaturesData {
  keyFeatures: {
    icon: string;
    badge: string;
    title: string;
    description: string;
    backgroundImage: string;
  };
}

export const KeyFeaturesConstants: KeyFeaturesData = {
  keyFeatures: {
    icon: fire,
    badge: "Key Features",
    title: "Our Key Features",
    description: " Precision in Every Tap",
    backgroundImage: feature1Bg,
  },
};
